var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { TIME_SPENT_BY_ACTIVITY_TYPE_APP } from '@web/config';
import { getUrl } from '@web/router/getUrl';
import { appsUrl } from '@web/router/urls';
import { ComparisonPeriod } from '@web/utility/comparisonPeriod';
import { appsActiveTabs } from '@web/utility/tabs';
import { ApplicationEnum, DriveEventActionEnum, DriveEventSubActionEnum, ItemsByType } from '@workalizer/shared';
import { buildPeriods, getInterval, getPeriodDateBoundsForInterval, getPreviousPeriod } from '@workalizer/shared/utils';
export { ComparisonPeriod };
var APP_USAGE_TAB_BY_APPLICATION = (_a = {},
    _a[ApplicationEnum.GMAIL] = 'gmail',
    _a[ApplicationEnum.CHAT] = 'chat',
    _a[ApplicationEnum.MEET] = 'meet',
    _a[ApplicationEnum.DRIVE] = 'drive',
    _a[ApplicationEnum.GEMINI] = 'gemini',
    _a);
var APPLICATION_BY_APP_USAGE_TAB = {
    gmail: ApplicationEnum.GMAIL,
    chat: ApplicationEnum.CHAT,
    meet: ApplicationEnum.MEET,
    drive: ApplicationEnum.DRIVE,
    gemini: ApplicationEnum.GEMINI
};
export function getChartDestinationForActivityType(key) {
    if (key === 'meetings') {
        return { kind: 'searchMeetings' };
    }
    if (key === 'documentWork') {
        return { kind: 'driveAdvancedSearch' };
    }
    if (key === 'communication') {
        return { kind: 'eventsLog', app: null };
    }
    var app = TIME_SPENT_BY_ACTIVITY_TYPE_APP[key];
    var appsTab = APP_USAGE_TAB_BY_APPLICATION[app];
    if (appsTab) {
        return { kind: 'apps', tab: appsTab };
    }
    return { kind: 'eventsLog', app: app };
}
export function getEventsLogDestinationForActivityType(key) {
    if (key === 'communication') {
        return { kind: 'eventsLog', app: null };
    }
    return {
        kind: 'eventsLog',
        app: TIME_SPENT_BY_ACTIVITY_TYPE_APP[key]
    };
}
export function getAppsUsageDestination(app) {
    var tab = APP_USAGE_TAB_BY_APPLICATION[app];
    if (tab) {
        return { kind: 'apps', tab: tab };
    }
    return { kind: 'eventsLog', app: app };
}
export function navigateToAppsUsageFromNameChartBarClick(_a) {
    var _b;
    var chartData = _a.chartData, barData = _a.barData, fallbackIndex = _a.fallbackIndex, tab = _a.tab, navigateTo = _a.navigateTo, dateFrom = _a.dateFrom, dateTo = _a.dateTo, userId = _a.userId, orgUnitId = _a.orgUnitId;
    var periodIndex = resolveChartBarPeriodIndexFromName(chartData, barData, fallbackIndex);
    navigateToChartDestinationFromPeriod({
        destination: { kind: 'apps', tab: tab },
        navigateTo: navigateTo,
        periodIndex: periodIndex,
        periodLabel: (_b = chartData[periodIndex]) === null || _b === void 0 ? void 0 : _b.name,
        rangeDateFrom: dateFrom,
        rangeDateTo: dateTo,
        userId: userId,
        orgUnitId: orgUnitId,
        stack: ComparisonPeriod.Current
    });
}
export function resolveChartPeriodDateBounds(_a) {
    var _b, _c;
    var periodIndex = _a.periodIndex, periodLabel = _a.periodLabel, dateFrom = _a.dateFrom, dateTo = _a.dateTo, _d = _a.stack, stack = _d === void 0 ? ComparisonPeriod.Current : _d;
    var _e = getPreviousPeriod(dateFrom, dateTo), prevPeriodDateFrom = _e.prevPeriodDateFrom, prevPeriodDateTo = _e.prevPeriodDateTo;
    var rangeFrom = stack === ComparisonPeriod.Current ? dateFrom : prevPeriodDateFrom;
    var rangeTo = stack === ComparisonPeriod.Current ? dateTo : prevPeriodDateTo;
    var rangeFromDate = new Date(rangeFrom);
    var rangeToDate = new Date(rangeTo);
    var interval = getInterval(rangeFromDate, rangeToDate);
    var periodBounds = getPeriodDateBoundsForInterval(interval, rangeFromDate, rangeToDate);
    var periodKeys = buildPeriods(rangeFromDate, rangeToDate, interval);
    var resolvedIndex = periodIndex;
    if (periodLabel) {
        var labelIndex = periodKeys.findIndex(function (period) { return period.key === periodLabel; });
        if (labelIndex >= 0) {
            resolvedIndex = labelIndex;
        }
    }
    var bounds = resolvedIndex >= 0 && resolvedIndex < periodBounds.length
        ? periodBounds[resolvedIndex]
        : null;
    return {
        dateFrom: (_b = bounds === null || bounds === void 0 ? void 0 : bounds.periodDateFrom) !== null && _b !== void 0 ? _b : rangeFrom,
        dateTo: (_c = bounds === null || bounds === void 0 ? void 0 : bounds.periodDateTo) !== null && _c !== void 0 ? _c : rangeTo
    };
}
export function resolveChartBarPeriodIndex(chartData, barData, fallbackIndex) {
    var _a;
    if (fallbackIndex === void 0) { fallbackIndex = 0; }
    var payload = barData && typeof barData === 'object' && 'payload' in barData
        ? barData.payload
        : undefined;
    var periodLabel = (_a = payload === null || payload === void 0 ? void 0 : payload.period) !== null && _a !== void 0 ? _a : payload === null || payload === void 0 ? void 0 : payload.name;
    if (periodLabel) {
        var index = chartData.findIndex(function (row) { return row.period === periodLabel; });
        if (index >= 0) {
            return index;
        }
    }
    return fallbackIndex >= 0 ? fallbackIndex : 0;
}
export function resolveChartBarPeriodIndexFromName(chartData, barData, fallbackIndex) {
    var _a;
    if (fallbackIndex === void 0) { fallbackIndex = 0; }
    var payload = barData && typeof barData === 'object' && 'payload' in barData
        ? barData.payload
        : barData &&
            typeof barData === 'object' &&
            ('name' in barData || 'period' in barData)
            ? barData
            : undefined;
    var periodLabel = (_a = payload === null || payload === void 0 ? void 0 : payload.period) !== null && _a !== void 0 ? _a : payload === null || payload === void 0 ? void 0 : payload.name;
    if (periodLabel) {
        var index = chartData.findIndex(function (row) { return row.name === periodLabel; });
        if (index >= 0) {
            return index;
        }
    }
    return fallbackIndex >= 0 ? fallbackIndex : 0;
}
export function getChartPeriodLabelForStack(row, stack) {
    if (!row) {
        return undefined;
    }
    if (stack === ComparisonPeriod.Previous) {
        return row.previousPeriodLabel || undefined;
    }
    return row.period;
}
function buildScopedBaseFilters(scope) {
    return {
        period: 'custom',
        dateFrom: scope.dateFrom,
        dateTo: scope.dateTo,
        user: scope.userId,
        orgUnit: scope.userId ? null : scope.orgUnitId,
        page: 1,
        pageSection: null,
        hasInitialSearch: true,
        scrollY: null,
        activityLabel: null
    };
}
export function navigateToChartDestination(destination, scope) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    var baseFilters = buildScopedBaseFilters(scope);
    switch (destination.kind) {
        case 'eventsLog':
            scope.navigateTo({
                pathname: getUrl(appsUrl, appsActiveTabs.eventsLog),
                newFilters: __assign(__assign({}, baseFilters), { app: (_a = destination.app) !== null && _a !== void 0 ? _a : null, activityLabel: (_b = destination.activityLabelId) !== null && _b !== void 0 ? _b : null })
            });
            return;
        case 'searchMeetings':
            scope.navigateTo({
                pathname: getUrl(appsUrl, appsActiveTabs.searchMeetings),
                newFilters: __assign(__assign({}, baseFilters), { app: ApplicationEnum.MEET, meetingType: (_c = destination.meetingType) !== null && _c !== void 0 ? _c : null, meetingDurationType: (_d = destination.meetingDurationType) !== null && _d !== void 0 ? _d : null, durationHours: (_e = destination.durationHours) !== null && _e !== void 0 ? _e : null, durationMinutes: (_f = destination.durationMinutes) !== null && _f !== void 0 ? _f : null, meetingParticipantsType: (_g = destination.meetingParticipantsType) !== null && _g !== void 0 ? _g : null, title: (_h = destination.title) !== null && _h !== void 0 ? _h : null, activityLabel: (_j = destination.activityLabelId) !== null && _j !== void 0 ? _j : null })
            });
            return;
        case 'driveAdvancedSearch':
            scope.navigateTo({
                pathname: getUrl(appsUrl, appsActiveTabs.driveAdvancedSearch),
                newFilters: __assign(__assign({}, baseFilters), { driveSearchTitle: (_k = destination.driveSearchTitle) !== null && _k !== void 0 ? _k : null, driveSearchType: (_l = destination.driveSearchType) !== null && _l !== void 0 ? _l : null, driveSearchAction: (_m = destination.driveSearchAction) !== null && _m !== void 0 ? _m : null, driveSearchSubAction: (_o = destination.driveSearchSubAction) !== null && _o !== void 0 ? _o : null, activityLabel: (_p = destination.activityLabelId) !== null && _p !== void 0 ? _p : null })
            });
            return;
        case 'apps':
            scope.navigateTo({
                pathname: getUrl(appsUrl, destination.tab),
                newFilters: __assign(__assign({}, baseFilters), { app: (_q = APPLICATION_BY_APP_USAGE_TAB[destination.tab]) !== null && _q !== void 0 ? _q : null, activityLabel: (_r = destination.activityLabelId) !== null && _r !== void 0 ? _r : null })
            });
    }
}
export function navigateToChartDestinationFromPeriod(_a) {
    var destination = _a.destination, navigateTo = _a.navigateTo, periodIndex = _a.periodIndex, periodLabel = _a.periodLabel, rangeDateFrom = _a.rangeDateFrom, rangeDateTo = _a.rangeDateTo, userId = _a.userId, orgUnitId = _a.orgUnitId, _b = _a.stack, stack = _b === void 0 ? ComparisonPeriod.Current : _b;
    var resolved = resolveChartPeriodDateBounds({
        periodIndex: periodIndex,
        periodLabel: periodLabel,
        dateFrom: rangeDateFrom,
        dateTo: rangeDateTo,
        stack: stack
    });
    navigateToChartDestination(destination, {
        navigateTo: navigateTo,
        dateFrom: resolved.dateFrom,
        dateTo: resolved.dateTo,
        userId: userId,
        orgUnitId: orgUnitId
    });
}
export function getBarChartRowPayload(barData) {
    if (barData && typeof barData === 'object' && 'payload' in barData) {
        return barData.payload;
    }
    if (barData && typeof barData === 'object') {
        return barData;
    }
    return undefined;
}
export function navigateToAppsUsageForDateRange(_a) {
    var navigateTo = _a.navigateTo, dateFrom = _a.dateFrom, dateTo = _a.dateTo, userId = _a.userId, orgUnitId = _a.orgUnitId, tab = _a.tab;
    navigateToChartDestination({ kind: 'apps', tab: tab }, { navigateTo: navigateTo, dateFrom: dateFrom, dateTo: dateTo, userId: userId, orgUnitId: orgUnitId });
}
export function navigateToEventsLogFromPeriodChartBarClick(_a) {
    var chartData = _a.chartData, barData = _a.barData, fallbackIndex = _a.fallbackIndex, stack = _a.stack, app = _a.app, navigateTo = _a.navigateTo, dateFrom = _a.dateFrom, dateTo = _a.dateTo, userId = _a.userId, orgUnitId = _a.orgUnitId;
    navigateChartPeriodBarClick({
        chartData: chartData,
        barData: barData,
        fallbackIndex: fallbackIndex,
        stack: stack,
        destination: { kind: 'eventsLog', app: app },
        navigateTo: navigateTo,
        dateFrom: dateFrom,
        dateTo: dateTo,
        userId: userId,
        orgUnitId: orgUnitId
    });
}
export function navigateChartPeriodBarClick(_a) {
    var chartData = _a.chartData, barData = _a.barData, fallbackIndex = _a.fallbackIndex, stack = _a.stack, destination = _a.destination, navigateTo = _a.navigateTo, dateFrom = _a.dateFrom, dateTo = _a.dateTo, userId = _a.userId, orgUnitId = _a.orgUnitId;
    var periodIndex = resolveChartBarPeriodIndex(chartData, barData, fallbackIndex);
    navigateToChartDestinationFromPeriod({
        destination: destination,
        navigateTo: navigateTo,
        periodIndex: periodIndex,
        periodLabel: getChartPeriodLabelForStack(chartData[periodIndex], stack),
        rangeDateFrom: dateFrom,
        rangeDateTo: dateTo,
        userId: userId,
        orgUnitId: orgUnitId,
        stack: stack
    });
}
export function navigateToEventsLogForDateRange(scope) {
    navigateToChartDestination({ kind: 'eventsLog', app: null }, scope);
}
export function navigateToEventsLogForApp(scope) {
    navigateToChartDestination({ kind: 'eventsLog', app: scope.app }, scope);
}
export function navigateToEventsLogFromChartPeriod(_a) {
    var navigateTo = _a.navigateTo, periodIndex = _a.periodIndex, periodLabel = _a.periodLabel, dateFrom = _a.dateFrom, dateTo = _a.dateTo, userId = _a.userId, orgUnitId = _a.orgUnitId, _b = _a.stack, stack = _b === void 0 ? ComparisonPeriod.Current : _b;
    navigateToChartDestinationFromPeriod({
        destination: { kind: 'eventsLog', app: null },
        navigateTo: navigateTo,
        periodIndex: periodIndex,
        periodLabel: periodLabel,
        rangeDateFrom: dateFrom,
        rangeDateTo: dateTo,
        userId: userId,
        orgUnitId: orgUnitId,
        stack: stack
    });
}
export function navigateToEventsLogFromChartPeriodForApp(_a) {
    var app = _a.app, navigateTo = _a.navigateTo, periodIndex = _a.periodIndex, periodRow = _a.periodRow, dateFrom = _a.dateFrom, dateTo = _a.dateTo, userId = _a.userId, orgUnitId = _a.orgUnitId, _b = _a.stack, stack = _b === void 0 ? ComparisonPeriod.Current : _b;
    navigateToChartDestinationFromPeriod({
        destination: { kind: 'eventsLog', app: app },
        navigateTo: navigateTo,
        periodIndex: periodIndex,
        periodLabel: periodRow
            ? getChartPeriodLabelForStack(periodRow, stack)
            : undefined,
        rangeDateFrom: dateFrom,
        rangeDateTo: dateTo,
        userId: userId,
        orgUnitId: orgUnitId,
        stack: stack
    });
}
export function navigateToEventsLogForEntityInRange(_a) {
    var navigateTo = _a.navigateTo, dateFrom = _a.dateFrom, dateTo = _a.dateTo, entityId = _a.entityId, groupEntitiesByUser = _a.groupEntitiesByUser;
    navigateToChartDestination({ kind: 'eventsLog', app: null }, {
        navigateTo: navigateTo,
        dateFrom: dateFrom,
        dateTo: dateTo,
        userId: groupEntitiesByUser ? entityId : null,
        orgUnitId: groupEntitiesByUser ? null : entityId
    });
}
export function getCommunicationWeekdayChannelFromBarDataKey(dataKey) {
    if (dataKey.includes('Meetings')) {
        return 'meetings';
    }
    if (dataKey.includes('Docs')) {
        return 'docs';
    }
    if (dataKey.includes('Chat')) {
        return 'chat';
    }
    if (dataKey.includes('Emails')) {
        return 'emails';
    }
    return null;
}
export function getCommunicationWeekdayDestination(channel) {
    switch (channel) {
        case 'emails':
            return { kind: 'apps', tab: 'gmail' };
        case 'chat':
            return { kind: 'apps', tab: 'chat' };
        case 'meetings':
            return { kind: 'searchMeetings' };
        case 'docs':
            return { kind: 'driveAdvancedSearch' };
    }
}
export function navigateCommunicationWeekdayBarClick(_a) {
    var stack = _a.stack, channel = _a.channel, navigateTo = _a.navigateTo, dateFrom = _a.dateFrom, dateTo = _a.dateTo, prevPeriodDateFrom = _a.prevPeriodDateFrom, prevPeriodDateTo = _a.prevPeriodDateTo, userId = _a.userId, orgUnitId = _a.orgUnitId;
    navigateToChartDestination(getCommunicationWeekdayDestination(channel), {
        navigateTo: navigateTo,
        dateFrom: stack === ComparisonPeriod.Current ? dateFrom : prevPeriodDateFrom,
        dateTo: stack === ComparisonPeriod.Current ? dateTo : prevPeriodDateTo,
        userId: userId,
        orgUnitId: orgUnitId
    });
}
export function getCollaborativeTimeAppsTab(dataKey) {
    if (dataKey.includes('Meetings')) {
        return 'meet';
    }
    if (dataKey.includes('Chats')) {
        return 'chat';
    }
    return 'gmail';
}
export function navigateToEventsLogForActivityLabel(_a) {
    var navigateTo = _a.navigateTo, dateFrom = _a.dateFrom, dateTo = _a.dateTo, userId = _a.userId, orgUnitId = _a.orgUnitId, activityLabelId = _a.activityLabelId, _b = _a.app, app = _b === void 0 ? null : _b;
    navigateTo({
        pathname: getUrl(appsUrl, appsActiveTabs.eventsLog),
        newFilters: __assign(__assign({}, buildScopedBaseFilters({
            navigateTo: navigateTo,
            dateFrom: dateFrom,
            dateTo: dateTo,
            userId: userId,
            orgUnitId: orgUnitId
        })), { app: app, activityLabel: activityLabelId })
    });
}
var INDEPENDENT_WORK_ACTIVITY_TAB = {
    docsCommentsPosted: 'drive',
    meetingsOrganized: 'meet',
    chatMessagesSent: 'chat',
    emailsSent: 'gmail'
};
export function getIndependentWorkActivityDestination(key) {
    return { kind: 'apps', tab: INDEPENDENT_WORK_ACTIVITY_TAB[key] };
}
export function navigateToIndependentWorkActivity(scope, key) {
    navigateToChartDestination(getIndependentWorkActivityDestination(key), scope);
}
export function navigateToIndependentWorkActivityFromPeriodBarClick(_a) {
    var chartData = _a.chartData, barData = _a.barData, fallbackIndex = _a.fallbackIndex, stack = _a.stack, activityKey = _a.activityKey, navigateTo = _a.navigateTo, dateFrom = _a.dateFrom, dateTo = _a.dateTo, userId = _a.userId, orgUnitId = _a.orgUnitId;
    navigateChartPeriodBarClick({
        chartData: chartData,
        barData: barData,
        fallbackIndex: fallbackIndex,
        stack: stack,
        destination: getIndependentWorkActivityDestination(activityKey),
        navigateTo: navigateTo,
        dateFrom: dateFrom,
        dateTo: dateTo,
        userId: userId,
        orgUnitId: orgUnitId
    });
}
export function navigateToDriveAdvancedSearch(scope, options) {
    var _a, _b, _c, _d, _e;
    navigateToChartDestination({
        kind: 'driveAdvancedSearch',
        driveSearchTitle: (_a = options === null || options === void 0 ? void 0 : options.driveSearchTitle) !== null && _a !== void 0 ? _a : null,
        driveSearchType: (_b = options === null || options === void 0 ? void 0 : options.driveSearchType) !== null && _b !== void 0 ? _b : null,
        driveSearchAction: (_c = options === null || options === void 0 ? void 0 : options.driveSearchAction) !== null && _c !== void 0 ? _c : null,
        driveSearchSubAction: (_d = options === null || options === void 0 ? void 0 : options.driveSearchSubAction) !== null && _d !== void 0 ? _d : null,
        activityLabelId: (_e = options === null || options === void 0 ? void 0 : options.activityLabelId) !== null && _e !== void 0 ? _e : null
    }, scope);
}
export var DRIVE_EXTERNAL_SHARE_SEARCH = {
    driveSearchAction: DriveEventActionEnum.DOCUMENT_SHARE,
    driveSearchSubAction: DriveEventSubActionEnum.DOCUMENT_SHARED_EXTERNALLY
};
export var DRIVE_INTERNAL_SHARE_SEARCH = {
    driveSearchAction: DriveEventActionEnum.DOCUMENT_SHARE,
    driveSearchSubAction: DriveEventSubActionEnum.DOCUMENT_SHARED_INTERNALLY
};
export function getDriveDocumentsActivitySearchFilters(rowKey, side) {
    switch (rowKey) {
        case 'created':
            return {
                driveSearchAction: DriveEventActionEnum.DOCUMENT_CREATE,
                driveSearchSubAction: null
            };
        case 'edited':
            return {
                driveSearchAction: DriveEventActionEnum.DOCUMENT_EDIT,
                driveSearchSubAction: null
            };
        case 'viewed':
            return {
                driveSearchAction: DriveEventActionEnum.DOCUMENT_VIEW,
                driveSearchSubAction: null
            };
        case 'shared':
            return side === 'right'
                ? {
                    driveSearchAction: DriveEventActionEnum.DOCUMENT_SHARE,
                    driveSearchSubAction: DriveEventSubActionEnum.DOCUMENT_SHARED_EXTERNALLY
                }
                : DRIVE_INTERNAL_SHARE_SEARCH;
        case 'comments':
            return {
                driveSearchAction: side === 'right'
                    ? DriveEventActionEnum.DOCUMENT_RESOLVE_COMMENT
                    : DriveEventActionEnum.DOCUMENT_CREATE_COMMENT,
                driveSearchSubAction: null
            };
        case 'suggestions':
            return {
                driveSearchAction: side === 'right'
                    ? DriveEventActionEnum.DOCUMENT_ACCEPT_SUGGESTION
                    : DriveEventActionEnum.DOCUMENT_CREATE_SUGGESTION,
                driveSearchSubAction: null
            };
    }
}
export function navigateToCreatedItemByType(scope, itemType, options) {
    var _a, _b, _c, _d, _e, _f;
    switch (itemType) {
        case ItemsByType.DOCUMENTS:
            navigateToChartDestination({
                kind: 'driveAdvancedSearch',
                driveSearchAction: (_a = options === null || options === void 0 ? void 0 : options.driveSearchAction) !== null && _a !== void 0 ? _a : DriveEventActionEnum.DOCUMENT_CREATE,
                driveSearchTitle: (_b = options === null || options === void 0 ? void 0 : options.driveSearchTitle) !== null && _b !== void 0 ? _b : null,
                activityLabelId: (_c = options === null || options === void 0 ? void 0 : options.activityLabelId) !== null && _c !== void 0 ? _c : null
            }, scope);
            return;
        case ItemsByType.MEETINGS:
            navigateToChartDestination({
                kind: 'searchMeetings',
                activityLabelId: (_d = options === null || options === void 0 ? void 0 : options.activityLabelId) !== null && _d !== void 0 ? _d : null
            }, scope);
            return;
        case ItemsByType.CHAT_ROOMS:
            navigateToChartDestination({
                kind: 'apps',
                tab: 'chat',
                activityLabelId: (_e = options === null || options === void 0 ? void 0 : options.activityLabelId) !== null && _e !== void 0 ? _e : null
            }, scope);
            return;
        case ItemsByType.CALENDAR_EVENTS:
            navigateToChartDestination({
                kind: 'eventsLog',
                app: ApplicationEnum.CALENDAR,
                activityLabelId: (_f = options === null || options === void 0 ? void 0 : options.activityLabelId) !== null && _f !== void 0 ? _f : null
            }, scope);
    }
}
